import { Component, OnInit, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { InputComboService } from '../services/input-combo.service';
import { Globals } from '../objects/Globals';
import { WorkspaceService } from '../services/workspace.service';

@Component({
  selector: 'app-input-combo',
  templateUrl: './input-combo.component.html',
  styleUrls: ['./input-combo.component.css']
})

export class InputComboComponent implements OnInit {
  comboList = [];
  selectedCombo: string;
  private comboId:string;
  private previousComboId:string;
  
  @Input() set createNewCombo(any: any){
    const type = "UserDepartmentList";
    this.inputComboService.createInputComboCard(type).subscribe(id => {
      if (id){
        this.comboId = id;
        this.inputComboService.getInputComboList(id).subscribe(result => {
          var inputCombo = JSON.parse(result);
          this.setDefaultValue(inputCombo); 
        })
      }
    })
  }

  @Input() set inputComboFilter(filter:string){
    if (filter){
      const type = "UserDepartmentList";
      this.inputComboService.createInputComboCard(type).subscribe(id => {
        if (id){
          this.comboId = id;
          this.inputComboService.getInputComboList(id, filter).subscribe(result => {
            if (result){
              var inputCombo = JSON.parse(result);
              this.setDefaultValue(inputCombo); 
            }
          })
        }
      })
    }
  }

  @Input() set setComboId(id: string){
    this.comboId = id;
    if(this.comboId){
      this.previousComboId = this.comboId;
      this.inputComboService.getInputComboList(this.comboId).subscribe(result => {
        if (result){
          var inputCombo = JSON.parse(result);
          this.setDefaultValue(inputCombo); 
        }
      })
    }
  }
  @Output() selectedComboIdChanged = new EventEmitter<string>();

  constructor(private inputComboService: InputComboService, private globals: Globals, private workspaceService: WorkspaceService) { }

  ngOnInit() {
  }

  getList(){
    
  }

  setDefaultValue(inputCombo: any){
    var i = 0;
    inputCombo.forEach(element => {
      if (i == 0) element.IsSelected = true;
      if(element.IsSelected){
        this.selectedCombo = element.SelectionValue;
      }
      i++;
    });

    this.selectedComboIdChanged.emit(this.selectedCombo); //probably no need or need
    this.comboList = inputCombo;
  }

  onValueChange(item){
    this.selectedComboIdChanged.emit(item.SelectionValue);
  }
}
